import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../services/user.service';
import { CourseNavigationService } from '../service/course-navigation.service';
import { environment } from '../../../environments/environment';
import { EncriptDecriptService } from '../../services/encriptdecript';

@Component({
  selector: 'app-saved-course',
  templateUrl: './saved-course.component.html',
  styleUrls: ['./saved-course.component.scss']
})
export class SavedCourseComponent implements OnInit {

  public bookmarkList: any[];
  public isCourseLoading = true;
  public isNoCourseList = false;
  public courseBannerUrl: string;
  public defaultBannerImagePath = '../../../assets/img/default-course-banner.jpg';
  public userObject:any;

  constructor(private userService: UserService,
    private encriptDecript:EncriptDecriptService,    
    private courseNavigationService: CourseNavigationService) {
      this.userObject = this.encriptDecript.getLocalStorage('userObject');
    this.isCourseLoading = true;
  }


  ngOnInit() {
    this.getBookmarkList();
  }

  /**
   * @description - Method to get the bookmarked course of the user.
   */
  private getBookmarkList() {
    const requestObject = {
      'userId': this.userObject ? JSON.parse(this.userObject).userId : null,
      'organisation': this.userObject ? JSON.parse(this.userObject).organisation.organisationId : null
    };
    const userObj = this.userObject ? this.userObject : null;
    this.userService.getBookMarkListServ(userObj).subscribe(response => {
      this.isCourseLoading = false;
      if (response['BookMark_Category_List']) {
        this.bookmarkList = response['BookMark_Category_List'];
        this.isNoCourseList = this.bookmarkList.length ? false : true;
        const ftpHost = environment['ftpHost']+environment['ftpRootDir'];
        this.courseBannerUrl =ftpHost? ftpHost:environment['cloudPath'];
        // this.courseBannerUrl =  environment.cloudPath;

      }
    });
  }

  removeFromBookmarkList(category) {
    const RequestObject = {
      isBookMarked: false,
      organisationId: category.organisation.organisationId,
      categoryId: category.categoryId,
      userId: JSON.parse(this.userObject).userId
    };
    this.userService.SaveBookMarkServ(RequestObject).subscribe(Response => {
      this.getBookmarkList();
    },(error)=>{
      if(error.status==401){

      }
      else{
        this.getBookmarkList();
      }
    });
  }

  onClickCourse(course) {
    this.courseNavigationService.navigateToCourse(course);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/saved-course/saved-course.component.ts